import React from 'react';

import ReportCompanyUsersTable from '../Table';

import { useStyles } from './styles';

export default ({ fields }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ReportCompanyUsersTable fields={fields} />
    </div>
  );
};
